module.exports = __webpack_public_path__ + "img/tick-square.35ded761.svg";